import React, { useEffect } from "react";
import { BundleInterface } from "src/store/watcher/bundlesSlice";

import { Button, Form, Input, Radio, Switch } from "antd";
import FileDropzone from "src/componets/FileDropzone";

interface propsInterface {
  params?: BundleInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <FileDropzone name='icon' label='Icon' preview={params?.icon_url} />

      <Form.Item name='name' label="Name">
        <Input disabled={!!params?.id} />
      </Form.Item>

      <Form.Item name='version' label="Version">
        <Input />
      </Form.Item>

      <Form.Item label="Force update" name='force_update' valuePropName='checked'>
        <Switch />
      </Form.Item>

      <Form.Item label="Platform" name='platform'>
        <Radio.Group>
          <Radio value='ios'>ios</Radio>
          <Radio value='android'>android</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
